import React, {memo, useCallback, useEffect, useState} from 'react';
import noImage from '../../assets/images/no-image.png';
import {useInterval} from '../../hooks/interval';
import {Configs} from '../../configs';

type Props =
    { interval?: number; disableErrorHandling?: boolean; disablePrefix?: boolean; }
    & React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>;
export const Image = memo(function Image(props: Props) {
    const {src: source, disableErrorHandling, disablePrefix, interval: rawInterval, alt, ...restOfProps} = props;

    const [hasError, setHasError] = useState(false);
    const [interval, setInterval] = useState(rawInterval);
    const [randomValue, setRandomValue] = useState(0);
    const [src, setSrc] = useState(() =>
        (disablePrefix ? '' : Configs.IMAGE_PREFIX) + source + (randomValue ? '?rand=' + randomValue : ''));

    useInterval(useCallback(() => setRandomValue(Math.random()), []), interval);

    const onError = useCallback(() => {
        setInterval(null);
        setHasError(true);
        //setSrc(noImage);
    }, []);

    useEffect(() => {
        if (hasError) {
            setSrc(source);
        }

        //setInterval(5000);
    }, [source, setSrc, hasError, rawInterval]);

    useEffect(() => {
        setHasError(false);
        setSrc(source);
    }, [source]);

    return (
        <img
            {...restOfProps}
            alt={alt}
            src={src}
            onError={onError}
        />
    );
});
